var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ClinicalForm',{attrs:{"form-key-prefix":"screening","title":'Screening'}})
}
var staticRenderFns = []

export { render, staticRenderFns }